import useWindow from 'hooks/useWindow';
import DopplerRadarContent from './components/DopplerRadarContent/DopplerRadarContent.jsx';

export default function DopplerRadar() {
  const { width } = useWindow();

  return <DopplerRadarContent scrollZoom={width >= 992} />;
}
